import { endOfWeek, format, isPast, isToday, isYesterday } from 'date-fns';

export function formatTimestamp(timestamp, unit, range) {
  switch (unit) {
    case 'hour':
      if (range === 'today' || range === 'yesterday') {
        return format(new Date(timestamp), 'HH:mm');
      } else {
        if (isToday(new Date(timestamp))) {
          return 'Today' + format(new Date(timestamp), ', HH:mm');
        } else if (isYesterday(new Date(timestamp))) {
          return 'Yesterday' + format(new Date(timestamp), ', HH:mm');
        } else {
          return format(new Date(timestamp), 'MMM dd, HH:mm');
        }
      }
    case 'day':
      if (isToday(new Date(timestamp))) {
        return 'Today';
      } else if (isYesterday(new Date(timestamp))) {
        return 'Yesterday';
      } else {
        return format(new Date(timestamp), 'MMM dd');
      }
    case 'week':
      return `${format(new Date(timestamp), 'MMM dd')} - ${format(
        endOfWeek(new Date(timestamp)),
        'MMM dd',
      )}`;
    case 'month':
      return format(new Date(timestamp), 'MMM yyyy');
    case 'year':
      return format(new Date(timestamp), 'yyyy');
    default:
      return format(new Date(timestamp), 'dd MMM');
  }
}

export function formatValue(timestamp, value) {
  if (isPast(new Date(timestamp))) {
    return value;
  }

  return 'No data';
}
